import React, { useState, useEffect, lazy, Suspense } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAdmin } from '../contexts/AdminContext';

const SocialLinks = lazy(() => import('./SocialLinks'));

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const { settings } = useAdmin();
  const location = useLocation();

  const toggleDropdown = (dropdownId) => {
    setOpenDropdownId((currentDropdownId) =>
      currentDropdownId === dropdownId ? null : dropdownId
    );
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
    setOpenDropdownId(null);
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  return (
    <header className={`navbar ${scrolled ? 'scrolled' : ''}`} role="banner">
      <div className="nav-container">
        {/* Logo */}
        <Link to="/" className="logo" aria-label={`${settings.companyName || 'TAXI ABEL'} - Retour à l'accueil`}>
          <span className="logo-mark" aria-hidden="true">T</span>
          <span className="logo-text">{settings.companyName || 'TAXI ABEL'}</span>
        </Link>

        {/* Navigation principale */}
        <nav
          className={`nav-menu ${isMenuOpen ? 'active' : ''}`}
          role="navigation"
          aria-label="Navigation principale"
        >
          <Link to="/" className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}>
            Accueil
          </Link>
          <Link to="/calculateur" className={`nav-link ${location.pathname === '/calculateur' ? 'active' : ''}`}>
            Calculateur
          </Link>
          <Link to="/blog" className={`nav-link ${location.pathname.startsWith('/blog') ? 'active' : ''}`}>
            Blog
          </Link>
          <div className={`nav-dropdown ${openDropdownId === 'villes' ? 'open' : ''}`}>
            <button
              type="button"
              className="nav-link nav-dropdown-trigger"
              aria-haspopup="true"
              aria-expanded={openDropdownId === 'villes'}
              onClick={() => toggleDropdown('villes')}
            >
              Villes ▾
            </button>
            <div className="nav-dropdown-menu" role="menu">
              <a href="/taxi-la-grand-croix" role="menuitem">La Grand-Croix</a>
              <a href="/taxi-rive-de-gier" role="menuitem">Rive-de-Gier</a>
              <a href="/taxi-saint-etienne" role="menuitem">Saint-Étienne</a>
              <a href="/taxi-lorette" role="menuitem">Lorette</a>
              <a href="/taxi-saint-chamond" role="menuitem">Saint-Chamond</a>
              <a href="/taxi-mornant" role="menuitem">Mornant</a>
              <a href="/taxi-givors" role="menuitem">Givors</a>
              <a href="/taxi-lyon" role="menuitem">Lyon</a>
            </div>
          </div>
          <div className={`nav-dropdown ${openDropdownId === 'services' ? 'open' : ''}`}>
            <button
              type="button"
              className="nav-link nav-dropdown-trigger"
              aria-haspopup="true"
              aria-expanded={openDropdownId === 'services'}
              onClick={() => toggleDropdown('services')}
            >
              Services ▾
            </button>
            <div className="nav-dropdown-menu" role="menu">
              <a href="/navette-aeroport" role="menuitem">Navette Aéroport</a>
              <a href="/taxi-aeroport-lyon" role="menuitem">Aéroport Lyon</a>
              <a href="/transport-medical" role="menuitem">Transport Médical</a>
              <a href="/taxi-gare" role="menuitem">Taxi Gare</a>
              <a href="/taxi-nuit" role="menuitem">Taxi de Nuit</a>
              <a href="/taxi-stations-ski" role="menuitem">Stations de Ski</a>
              <a href="/course-urgente" role="menuitem">Course Urgente</a>
            </div>
          </div>
        </nav>

        {/* Infos de contact */}
        <div className="contact-info">
          <a
            href={`tel:${settings.phone || '+33477123456'}`}
            className="phone-link"
            aria-label="Appeler Taxi Abel"
          >
            <span className="phone-number">{settings.phone || '04 77 12 34 56'}</span>
          </a>
          <Suspense fallback={null}>
            <SocialLinks />
          </Suspense>
          <button
            className={`mobile-menu-toggle ${isMenuOpen ? 'open' : ''}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
            aria-expanded={isMenuOpen}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      {/* Overlay mobile */}
      {isMenuOpen && (
        <div
          className="nav-overlay"
          onClick={() => setIsMenuOpen(false)}
          aria-hidden="true"
        />
      )}
    </header>
  );
}

export default Header;
